<div class="skl-stats-content" aria-busy="true" aria-label="Loading statistics">

  <!-- KPI section label -->
  <app-skeleton width="60px" height="12px" borderRadius="3px" marginBottom="8px" class="d-block"></app-skeleton>

  <!-- KPI grid row — 4 cards -->
  <div class="skl-kpi-grid mb-3">
    @for (col of kpiCols; track col) {
      <div class="skl-kpi-card">
        <div class="skl-kpi-card__content">
          <app-skeleton width="65%" height="12px" borderRadius="3px" marginBottom="8px"></app-skeleton>
          <app-skeleton width="45%" height="24px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-kpi-card__icon">
          <app-skeleton width="32px" height="32px" borderRadius="50%" marginBottom="0"></app-skeleton>
        </div>
      </div>
    }
  </div>

  <!-- Second KPI row -->
  <app-skeleton width="140px" height="12px" borderRadius="3px" marginBottom="8px" class="d-block"></app-skeleton>
  <div class="skl-kpi-grid mb-3">
    @for (col of kpiCols; track col) {
      <div class="skl-kpi-card">
        <div class="skl-kpi-card__content">
          <app-skeleton width="70%" height="12px" borderRadius="3px" marginBottom="8px"></app-skeleton>
          <app-skeleton width="50%" height="24px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-kpi-card__icon">
          <app-skeleton width="32px" height="32px" borderRadius="50%" marginBottom="0"></app-skeleton>
        </div>
      </div>
    }
  </div>

  <!-- Third KPI row (3 cards) -->
  <app-skeleton width="100px" height="12px" borderRadius="3px" marginBottom="8px" class="d-block"></app-skeleton>
  <div class="skl-kpi-grid skl-kpi-grid-3 mb-4">
    @for (col of kpiRows; track col) {
      <div class="skl-kpi-card">
        <div class="skl-kpi-card__content">
          <app-skeleton width="60%" height="12px" borderRadius="3px" marginBottom="8px"></app-skeleton>
          <app-skeleton width="40%" height="24px" borderRadius="4px" marginBottom="0"></app-skeleton>
        </div>
        <div class="skl-kpi-card__icon">
          <app-skeleton width="32px" height="32px" borderRadius="50%" marginBottom="0"></app-skeleton>
        </div>
      </div>
    }
  </div>

  <!-- Data table card -->
  <div class="skl-table-card">
    <div class="skl-table-card__header">
      <app-skeleton width="160px" height="14px" borderRadius="3px" marginBottom="0"></app-skeleton>
    </div>
    <!-- Table header row -->
    <div class="skl-table-head-row">
      @for (col of tableCols; track col) {
        <div class="skl-table-cell">
          <app-skeleton width="70%" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
      }
    </div>
    <!-- Table data rows -->
    @for (row of tableRows; track row) {
      <div class="skl-table-data-row">
        @for (col of tableCols; track col) {
          <div class="skl-table-cell">
            <app-skeleton [width]="col === 1 ? '80%' : col === 2 ? '65%' : '55%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
          </div>
        }
      </div>
    }
    <!-- Pagination -->
    <div class="skl-table-pagination">
      <app-skeleton width="150px" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
      <div class="d-flex gap-1">
        @for (btn of [1,2,3,4]; track btn) {
          <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
        }
      </div>
    </div>
  </div>

</div>
